// Email validation utility functions

// Regular expressions for email validation
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Default blocked domains
export const DEFAULT_BLOCKED_DOMAINS = [
  { regex: /^[^\s@]+@gmail\.(com?|co|c)$/, message: "Free Gmail email services are not allowed. Please use your organization email address." },
  { regex: /^[^\s@]+@yahoo\.(com?|co|c)$/, message: "Free Yahoo email services are not allowed. Please use your organization email address." },
  { regex: /^[^\s@]+@hotmail\.(com?|co|c)$/, message: "Free Hotmail email services are not allowed. Please use your organization email address." },
  { regex: /^[^\s@]+@outlook\.(com?|co|c)$/, message: "Free Outlook email services are not allowed. Please use your organization email address." },
  { regex: /^[^\s@]+@icloud\.(com?|co|c)$/, message: "Free iCloud email services are not allowed. Please use your organization email address." }
];

/**
 * Validates an email address and returns validation result
 * @param {string} email - The email address to validate
 * @param {Object} options - Validation options
 * @param {boolean} options.allowFreeEmail - Whether to allow free email services
 * @param {Array} options.blockedDomains - Array of objects with regex and message for blocked domains
 * @returns {Object} - Validation result with isValid and error message
 */
export const validateEmail = (email, options = {}) => {
  const { allowFreeEmail = false, blockedDomains = DEFAULT_BLOCKED_DOMAINS } = options;

  if (!email) {
    return {
      isValid: false,
      error: "Please enter an email address."
    };
  }

  if (!EMAIL_REGEX.test(email)) {
    return {
      isValid: false,
      error: "Please enter a valid email address."
    };
  }

  if (!allowFreeEmail) {
    for (const domain of blockedDomains) {
      if (domain.regex.test(email)) {
        return {
          isValid: false,
          error: domain.message
        };
      }
    }
  }

  return {
    isValid: true,
    error: ""
  };
};

/**
 * Handles email change event and updates state accordingly
 * @param {Event} e - The change event
 * @param {Function} setEmail - Function to set email state
 * @param {Function} setError - Function to set error state
 * @param {Function} setFilledUp - Function to set filledUp state
 * @param {Object} options - Validation options
 * @param {boolean} options.allowFreeEmail - Whether to allow free email services
 * @param {Array} options.blockedDomains - Array of objects with regex and message for blocked domains
 */
export const validateAndHandleEmailChange = (e, setEmail, setError, setFilledUp, options = {}) => {
  const value = e.target.value;
  setEmail(value);
  
  const validation = validateEmail(value, options);
  setError(validation.error);
  setFilledUp(!validation.error && value.trim() !== "");
}; 